// a list of tokens by chain
import { Currency, Token } from '@uniswap/sdk-core'

import { SupportedChainId } from './chains'
import { CRN, DAI, FRAX, nativeOnChain, TST, USDC, USDT, WETH, WRAPPED_NATIVE_CURRENCY } from './tokens'

type ChainTokenList = {
  readonly [chainId: number]: Token[]
}

type ChainCurrencyList = {
  readonly [chainId: number]: Currency[]
}

const WRAPPED_NATIVE_CURRENCIES_ONLY: ChainTokenList = Object.fromEntries(
  Object.entries(WRAPPED_NATIVE_CURRENCY).map(([key, value]) => [key, [value]])
)

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
  //TODO probably need to review this based on the native currency
  [SupportedChainId.MAINNET]: [
    ...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.MAINNET],
    USDC[SupportedChainId.MAINNET],
    FRAX[SupportedChainId.MAINNET],
  ],
  [SupportedChainId.EVMOS_TESTNET]: [
    ...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.EVMOS_TESTNET],
    USDC[SupportedChainId.EVMOS_TESTNET],
  ],
  [SupportedChainId.RINKEBY]: [
    ...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.RINKEBY],
    USDC[SupportedChainId.RINKEBY],
  ],
}
export const ADDITIONAL_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {
  // [SupportedChainId.MAINNET]: {
  //   '0xF16E4d813f4DcfDe4c5b44f305c908742De84eF0': [ETH2X_FLI],
  // },
}
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {
  // [SupportedChainId.MAINNET]: {
  //   [AMPL.address]: [DAI, WRAPPED_NATIVE_CURRENCY[SupportedChainId.MAINNET]],
  // },
}

/**
 * Shows up in the currency select for swap and add liquidity
 */
export const COMMON_BASES: ChainCurrencyList = {
  [SupportedChainId.MAINNET]: [
    nativeOnChain(SupportedChainId.MAINNET),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.MAINNET],
    USDC[SupportedChainId.MAINNET],
    WETH[SupportedChainId.MAINNET],
  ],
  [SupportedChainId.EVMOS_TESTNET]: [
    nativeOnChain(SupportedChainId.EVMOS_TESTNET),
    TST,
    CRN[SupportedChainId.EVMOS_TESTNET],
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.EVMOS_TESTNET],
  ],
  [SupportedChainId.RINKEBY]: [
    nativeOnChain(SupportedChainId.RINKEBY),
    CRN[SupportedChainId.RINKEBY],
    USDC[SupportedChainId.RINKEBY],
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.RINKEBY],
  ],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
}
export const PINNED_PAIRS: { readonly [chainId: number]: [Token, Token][] } = {
  [SupportedChainId.MAINNET]: [
    [
      new Token(SupportedChainId.MAINNET, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643', 8, 'cDAI', 'Compound Dai'),
      new Token(
        SupportedChainId.MAINNET,
        '0x39AA39c021dfbaE8faC545936693aC917d5E7563',
        8,
        'cUSDC',
        'Compound USD Coin'
      ),
    ],
    [USDC[SupportedChainId.MAINNET], USDT[SupportedChainId.MAINNET]],
    [DAI[SupportedChainId.MAINNET], USDT[SupportedChainId.MAINNET]],
  ],
}
